<template>
  <div
    class="h-screen flex w-full"
    id="page-login"
    style="
      background-image: url(http://petrol.excise-online.com/images/bg-pattern.png);
    "
  >
    <v-wait for="my-load">
      <template slot="waiting">
        <div class="h-full w-full loading">
          <img class="img-loading h-full w-full" src="@/assets/loading.gif" />
        </div>
      </template>

      <!-- <button @click="load">Load list again.</button> -->
    </v-wait>

    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card card="shadow">
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div
              class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center"
            >
              <img
                src="http://petrol.excise-online.com/images/sappasammit.png"
                alt="login"
                class="mx-auto"
              />
            </div>
            <div
              class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg"
            >
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">ระบบตรวจสอบเฝ้าระวังการจำหน่ายน้ำมัน</h4>
                  <p>สำหรับชาวประมงในเขตต่อเนื่องของราชอาณาจักร</p>
                </div>
                <vs-input
                  required
                  name="username"
                  icon="icon icon-user"
                  icon-pack="feather"
                  label-placeholder="ชื่อผู้ใช้งาน"
                  v-model="username"
                  class="w-full no-icon-border"
                  @keypress.enter="onLogin()"
                />
                <vs-input
                  required
                  type="password"
                  name="password"
                  icon="icon icon-lock"
                  icon-pack="feather"
                  label-placeholder="รหัสผ่าน"
                  v-model="password"
                  class="w-full mt-6 no-icon-border"
                  @keypress.enter="onLogin()"
                />
                <!-- <div class="flex flex-wrap justify-between my-5">
                  <vs-checkbox v-model="checkbox_remember_me"
                    >จดจำรหัสผ่าน</vs-checkbox
                  >
                  <router-link>ลืมรหัสผ่าน?</router-link>
                </div> -->
                <vs-button
                  class="float-right my-10"
                  @keypress.enter="onLogin()"
                  @click="onLogin"
                  >เข้าสู่ระบบ</vs-button
                >
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import _ from "lodash";

export default {
  data() {
    return {
      username: "",
      password: "",
      checkbox_remember_me: false,
    };
  },
  computed: {
    ...mapState({
      loading: (state) => state.auth.loading,
      error: (state) => state.auth.error,
      isLoginSuccess: (state) => state.auth.isLoginSuccess,
    }),
  },
  watch: {
    loading(loading) {
      if (loading) {
        this.$wait.start("my-load");
        // this.$vs.loading();
      } else {
        // this.$wait.end("my-load");
        // this.$vs.loading.close();
      }
    },
    error(error) {
      setTimeout(() => {
        this.$wait.end("my-load");
        if (!_.isEmpty(error)) {
          this.$fire({
            type: "error",
            title: "เข้าสู่ระบบไม่สำเร็จ",
            text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง",
          });
        }
      }, 1000);
    },
    isLoginSuccess(success) {
      if (success) {
        this.loginSuccess();
      }
    },
  },
  created() {
    this.$wait.start("my-load");
    setTimeout(() => {
      this.$wait.end("my-load");
    }, 2000);
  },
  methods: {
    onLogin() {
      this.$store.dispatch("login", {
        username: this.username,
        password: this.password,
      });
    },
    onRegister() {
      this.$router.push("/");
    },
    loginSuccess() {
      if (this.username == "admin") {
        this.$acl.change("admin");
        localStorage.setItem("userRole", "admin");
      } else {
        this.$acl.change("user");
        localStorage.setItem("userRole", "user");
      }
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss">
#page-login {
  .social-login {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #1551b1;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
.loading {
  z-index: 1000;
  display: flex;
  justify-items: center;
  justify-content: center;
  align-items: center;
  position: absolute;
  background: rgba($color: #000000, $alpha: 0.3);
}
.img-loading {
  z-index: 1000;
}

</style>
